<div class="login-wrapper">
  <span class="logo">
    <img [src]="environment.logoImage" alt="" />
  </span>
  @if (formState$ | async; as formState) {
    <form [formGroup]="loginForm" class="login-form">
      <div class="login-form__title">Login</div>
      <label>
        <span>ID or Email</span>
        <input data-e2e="login-email" formControlName="email" type="text" />
      </label>
      <label>
        <span>Password</span>
        <input data-e2e="login-password" formControlName="password" type="password" />
      </label>
      @if (formState?.errors) {
        <span class="login-form__error">Wrong email or password</span>
      }
      <div class="login-form__buttons">
        <button (click)="signIn()" [disabled]="formState?.errors" class="login-btn" data-e2e="login-submit">Log In
        </button>
        @if (isLoginWithMicrosoft) {
          <button
            (click)="getLoginUseMicrosoft()"
            class="sign-with-microsoft">
            <img alt="microsoft" src="assets/img/icons/icons8-microsoft.svg" />
            Sign in
          </button>
        }
      </div>
    </form>
  }
</div>
